<template>
    <div :id="fileid" class="row mb-prj align-items-center bg-shade-light small-collapse">
        <div class="column large-1 flex-child-fix" v-if="!compact">
            <figure class="content-list__figure bg-shade embed-responsive embed-responsive-1/1 position-relative flex-child-fix">
                <img :src="iconURL" v-if="!isPDF" class="object-fit-contain" alt="no image available">
                <PdfPreview v-if="isPDF" :file="internalFile"></PdfPreview>
            </figure>
        </div>
        <div class="column small-5 medium-7">
            <div class="content-list__desc d-block mx-prj2 line-height-12 text-xsmall text-small@medium text-left">
                <span class="font-weight-bold text-break">{{filename}}</span>
                <!-- <span class="text-small">(17.0 kB)</span>  -->
            </div>
        </div>
        <div class="column small-3 d-flex align-content-center">
            <div class="status">
                <div v-if="filestatus===FILESTATUS.OK" class="upload__success text-success d-flex align-items-center">
                    <svg xmlns="http://www.w3.org/2000/svg" x="0" y="0" viewBox="0 0 36 36" xml:space="preserve" class="svg-icon upload-icon svg-icon--large mr-2 show-for-medium">
                        <path d="M36 18.01c0 9.94-8.04 17.98-17.99 17.99C8.03 36.01-.01 27.95 0 17.93 0 8.04 8.09-.01 18.02 0 27.96.01 36 8.06 36 18.01z" fill="#62b982"/>
                        <path id="XMLID_1_" d="M14.93 26.67l-6.46-6.46a2.07 2.07 0 010-2.93 2.07 2.07 0 012.93 0l3.55 3.55 9.66-9.56c.81-.8 2.12-.8 2.93.02.8.81.8 2.12-.02 2.93L14.93 26.67z" fill="#fff"/>
                    </svg>
                    <div v-if="!compact" class="text-xxsmall text-small@medium text-center">{{'txtFileUploaded'|translate}}</div>
                </div>
                <div v-else-if="filestatus===FILESTATUS.ERROR_FILETYPE" class="upload__error d-flex align-items-center">
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 36 36" class="svg-icon upload-icon svg-icon--large mr-2 show-for-medium"><circle cx="18" cy="18" r="18" fill="#e94d47"/><path d="M16.08 26.43c0-.3.05-.58.17-.85.11-.27.26-.5.46-.69.2-.19.43-.35.7-.46.27-.12.56-.17.86-.17.3 0 .58.06.85.17.27.12.5.27.69.46.19.19.34.42.46.69.12.27.17.55.17.85 0 .31-.06.59-.17.86-.12.26-.27.49-.46.68-.19.19-.42.34-.69.45a2.223 2.223 0 01-1.71 0c-.27-.11-.5-.26-.7-.45-.2-.19-.35-.42-.46-.68-.11-.27-.17-.55-.17-.86zm3.9-18.86v8.24c0 .87-.04 1.73-.13 2.57-.09.84-.2 1.73-.34 2.67h-2.4c-.14-.94-.26-1.83-.35-2.67-.09-.84-.13-1.7-.13-2.57V7.57h3.35z" fill="#fff"/></svg>
                    <div v-if="!compact" class="text-error text-xxsmall text-small@medium text-center">{{'txtErrorFileUpload'|translate}}</div>
                </div>
                <div v-else-if="filestatus===FILESTATUS.ERROR_FILESIZE" class="upload__error d-flex align-items-center">
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 36 36" class="svg-icon upload-icon svg-icon--large mr-2 show-for-medium"><circle cx="18" cy="18" r="18" fill="#e94d47"/><path d="M16.08 26.43c0-.3.05-.58.17-.85.11-.27.26-.5.46-.69.2-.19.43-.35.7-.46.27-.12.56-.17.86-.17.3 0 .58.06.85.17.27.12.5.27.69.46.19.19.34.42.46.69.12.27.17.55.17.85 0 .31-.06.59-.17.86-.12.26-.27.49-.46.68-.19.19-.42.34-.69.45a2.223 2.223 0 01-1.71 0c-.27-.11-.5-.26-.7-.45-.2-.19-.35-.42-.46-.68-.11-.27-.17-.55-.17-.86zm3.9-18.86v8.24c0 .87-.04 1.73-.13 2.57-.09.84-.2 1.73-.34 2.67h-2.4c-.14-.94-.26-1.83-.35-2.67-.09-.84-.13-1.7-.13-2.57V7.57h3.35z" fill="#fff"/></svg>
                    <div v-if="!compact" class="text-error text-xxsmall text-small@medium text-center">{{'txtErrorFileTooBig'|translate}}</div>
                </div>
                <div v-else class="upload__uploading">
                    <svg xmlns:svg="http://www.w3.org/2000/svg" class="svg-icon upload-icon m-auto svg-icon--large position-relative t-2px" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.0" width="64px" height="64px" viewBox="0 0 128 128" xml:space="preserve"><rect x="0" y="0" width="100%" height="100%" fill="#E1E6EE" /><g><path fill="#0096d1" fill-opacity="1" d="M109.25 55.5h-36l12-12a29.54 29.54 0 0 0-49.53 12H18.75A46.04 46.04 0 0 1 96.9 31.84l12.35-12.34v36zm-90.5 17h36l-12 12a29.54 29.54 0 0 0 49.53-12h16.97A46.04 46.04 0 0 1 31.1 96.16L18.74 108.5v-36z"/><animateTransform attributeName="transform" type="rotate" from="0 64 64" to="360 64 64" dur="1120ms" repeatCount="indefinite"></animateTransform></g></svg>
                </div>
            </div>
        </div>
        <div class="column large-1 d-flex align-content-center" v-if="filestatus!==FILESTATUS.LOADING">
            <button @click="$emit('delete-file')" type="button" class="btn btn--link m-auto w-auto p-0 border-0 position-relative tn-1px">
                <div class="icon-up-delete"></div>
            </button>
        </div>

    </div>
</template>

<script>
    import PdfPreview from "components/PdfPreview.vue";

    import {ProduktRESTHelper} from "../classes/api";

    export const FILESTATUS = {
        LOADING: 0,
        OK: 1,
        ERROR_FILETYPE: 2,
        ERROR_FILESIZE: 3
    };
    export const MAX_FILESIZE = 524288000; // 500MB in Bytes, matches MAX_FILESIZE in basket-view.js

    export default {
        components: {PdfPreview},
        props: ['filename', 'fileid', 'filestatus', 'file', 'url', 'compact'],
        data() {
            return{
                internalFile:this.file,
                isPDF: this.internalFile?.type === "application/pdf" || this.filename.toLowerCase().endsWith(".pdf"),
                FILESTATUS: FILESTATUS,
                iconURL: ""
            }
        },
        mounted() {
          this.helper = new ProduktRESTHelper(window.FlyerlineConfig.product_key);

          if( this.isPDF && this.url ) {
                fetch(this.url)
                .then( resp => resp.blob() ).then(blob => {
                    this.internalFile = new File([blob], this.filename, {type: "application/pdf"})
                } )
            }

          let data = {filenames: [this.filename] }
          this.helper.get("api/prj/product/conf/uploadpreview." + languagepath + ".json", data)
              .then(response => {
                this.iconURL = response[this.filename]
              })
              .catch(xhr => console.log("ERROR: Failed to load icons for uploaded files!"));
        }
    }
</script>